import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import Buttons from "../../../library/custom/button/Button";
import GridTable from "../../../library/custom/gridTable/GridTable";
import {
  API_STATUS,
  ASSET_TYPE_JHA,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  USER_ID,
} from "../../../constant/constant";
import { TableLoader } from "../../../library/common/Loader";
import NORow from "../../../library/custom/noRow/noRow";
import ReportRowManipulte from "../../incidents/incidentList/ReportRowManipulte";
import { useNavigate } from "react-router-dom";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterCommonStatusSelect from "../../admin/shared/FilterCommonStatusSelect";
import { getFormatedDate } from "../../../utils/helper";
import {
  CONDUCT_JHA,
  CONDUCT_JHA_REPORT,
} from "../../../constant/routeContant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import downloadIcon from "../../../assets/downloadIcon.svg";
import DialogBox from "../../../library/common/DialogBox";

export default function ConductJhaList({
  getConductJhaList,
  conductJhaListData,
  isLoading,
  NavigateAddConductjha,
  deleteConductJha,
  deleteConductJhaData,
}) {
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [asetType, setAssetType] = useState();
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [page, setPage] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isTableLoading, setisTableLoading] = useState(false);
  const [conductJhaListApiData, setConductJhaListApiData] = useState({
    page: 1,
    pageSize: pageSize,
    search: "",
    endDate: toDate ? getFormatedDate(toDate) : "",
    startDate: fromDate ? getFormatedDate(fromDate) : "",
    userId: 0,
    assetType: 0,
    isSendMail: false,
  });
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const deletehandle = () => {
    const data = {
      conductId: selectedRow?.id,
      userId: parseInt(USER_ID()),
    };
    deleteConductJha(data);
  };

  useEffect(() => {
    if (deleteConductJhaData.status === API_STATUS.SUCCESS) {
      const defaultData = {
        page: 1,
        pageSize: pageSize,
        search: "",
        endDate: "",
        startDate: "",
        userId: 0,
        assetType: 0,
        isSendMail: false,
      };
      getConductJhaList(defaultData);
      setOpenModal(false);
    }
  }, [deleteConductJhaData]);

  const onchangeToDatePicker = (e) => {
    setToDate(e);
  };
  const onchangeFromDatePicker = (e) => {
    setFromDate(e);
  };

  const [filter, setFilter] = useState({
    page: 1,
    pageSize: pageSize,
    search: "",
    endDate: toDate ? getFormatedDate(toDate) : "",
    startDate: fromDate ? getFormatedDate(fromDate) : "",
    userId: 0,
    assetType: asetType ? asetType : 0,
    isSendMail: false,
  });

  const assetTypeOnChanges = (e) => {
    setAssetType(e.target.value);
  };

  const handleSearch = (data) => {
    setAnchorEl(null);
    getConductJhaList(data);
  };

  const handleApply = (state) => {
    setPage(1);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);

    setConductJhaListApiData({
      ...conductJhaListApiData,
      endDate: toDate ? getFormatedDate(toDate) : "",
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      assetType: asetType ? asetType : 0,
      isSendMail: false,
    });
    setAnchorEl(null);
    const data = {
      ...conductJhaListApiData,
      page: 1,
      pageSize: pageSize,
      search: "",
      endDate: toDate ? getFormatedDate(toDate) : "",
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      userId: 0,
      assetType: asetType ? asetType : 0,
      isSendMail: false,
    };
    getConductJhaList(data);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
//pagination
  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize)
      getConductJhaList({
        ...conductJhaListApiData,
        isSendMail: false,
      page: page,
      pageSize: newPazeSize,
    });
    };

  const handlePagignation = (newPage) => {
    setPage(newPage + 1);
    const data = {
      ...conductJhaListApiData,
      page: newPage + 1,
      isSendMail: false,
    };
    setConductJhaListApiData({
      ...conductJhaListApiData,
      page: newPage + 1,
      isSendMail: false,
    });
    getConductJhaList(data);
  };

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
    const data = {
      ...conductJhaListApiData,
      search: searchText ? searchText : "",
      page: 1,
      isSendMail: false,
    };
    setPage(1);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setConductJhaListApiData({
      ...conductJhaListApiData,
      search: searchText ? searchText : "",
    });
    getConductJhaList(data);
  };

  const handleClear = () => {
    setFromDate("");
    setToDate("");
    setAssetType("");
    setSearch("");
    const data = {
      page: 1,
      pageSize: pageSize,
      search: "",
      endDate: "",
      startDate: "",
      userId: 0,
      assetType: 0,
      isSendMail: false,
    };
    setPage(1);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setConductJhaListApiData(data);
    handleSearch(data);
  };

  const handleOnViewclick = (rows) => {
    navigate(CONDUCT_JHA_REPORT, {
      state: { id: rows.row.id, editMode: true },
    });
  };

  const handleOnEditclick = (rows) => {
    navigate(CONDUCT_JHA, {
      state: { id: rows.row.id, editMode: true },
    });
  };
  const handleOnDeleteclick = (rows) => {
    setOpenModal(true);
    setSelectedRow(rows);
  };

  const onRowClick = (rows) => {
    if (rows.value) {
      navigate(CONDUCT_JHA_REPORT, {
        state: { id: rows.row.id, editMode: true },
      });
    }
  };

  const credcloumns = [
    { field: "id", headerName: "ID", flex: 2.8 },
    { field: "templateName", headerName: "Templates Name", flex: 4 },
    { field: "dateOfEntry", headerName: "Date of Entry", flex: 4 },
    { field: "assetName", headerName: "Asset Name", flex: 4 },
    { field: "assetType", headerName: "Asset Type", flex: 3.5 },
    { field: "conductedBy", headerName: "Conducted by", flex: 3.4 },
    {
      field: "",
      width: 80,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            credentialLists={true}
            viewOnClick={() => handleOnViewclick(rows)}
            edit={checkPrivileges([12, 123, 124])}
            editLabel="Edit Hazard Analysis Report"
            editOnClick={() => handleOnEditclick(rows)}
            download={false}
            view={checkPrivileges([12, 123, 124, 125])}
            viewLabel="View Hazard Analysis Report"
            deleted={checkPrivileges([12, 123])}
            deleteLabel="Delete Hazard Analysis Report"
            deleteOnClick={() => handleOnDeleteclick(rows)}
          />
        );
      },
    },
  ];

  const sendEmail = () => {
    const data = {
      ...conductJhaListApiData,
      isSendMail: true,
    };
    setConductJhaListApiData(data);
    getConductJhaList(data);
  };
  return (
    <>
      <section className="grid_main_sec">
        <div className="grid_main_header two_grid">
          <div className="grid_heading_style">Hazard Analysis Reports</div>
          {openModal && (
            <DialogBox
              open={openModal}
              rows={[]}
              header={"Confirm Deletion"}
              deletehandle={deletehandle}
              handleCloseModal={() => setOpenModal(false)}
              content={
                "Are you sure you want to delete this hazard analysis report?"
              }
              view
            />
          )}
          <div>
            <div className="filter_btn">
              {checkPrivileges([123, 124, 12]) && (
                <Buttons
                  id="btnAddClient"
                  label={"Add Hazard Analysis Report"}
                  varientAddIconBlue={true}
                  onClick={NavigateAddConductjha}
                ></Buttons>
              )}
            </div>
          </div>
        </div>
        <div className="grid_main_body">
          <div className="div-filter-container">
            <div className="filter_of_caselist">
              <div className="searchcaseid">
                <label htmlFor="search">
                  <span>
                    <SearchIcon />
                  </span>
                  <div>
                    <input
                      id="search"
                      placeholder="Search"
                      type="text"
                      value={search}
                      className=""
                      onChange={handleautoSearch}
                      autoComplete="off"
                    />
                  </div>
                </label>
              </div>

              <div className="filter_btn">
                <button
                  aria-describedby={id}
                  variant="contained"
                  type="button"
                  name="btn"
                  onClick={(e) => handleClick(e)}
                >
                  <FilterListIcon id="icn" /> Filters
                </button>
                <FilterCommonStatusSelect
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  handleClose={handleClose}
                  handleApply={handleApply}
                  handleClear={handleClear}
                  filter={filter}
                  selectLable={"Asset Type"}
                  categoryType={ASSET_TYPE_JHA}
                  category={asetType}
                  categoryOnChanges={assetTypeOnChanges}
                  filterSelect={true}
                  resetBtn={true}
                  filterDate={true}
                  toDate={toDate}
                  fromDate={fromDate}
                  onchangeToDatePicker={onchangeToDatePicker}
                  onchangeFromDatePicker={onchangeFromDatePicker}
                  minDate={true}
                />
              </div>
            </div>
            <div className="div-download-email-right" onClick={sendEmail}>
              <span>
                <img
                  src={downloadIcon}
                  className="DownLoadLogo"
                  alt="DownLoad Logo"
                />
              </span>
              Download Data
            </div>
          </div>

          <div className="desc_box row_uniq">
            <div className="table_style_ui">
              {isTableLoading ? (
                ""
              ) : (
                <GridTable
                  getRowId={(r) => r.id}
                  rows={conductJhaListData?.data?.result?.itemList ?? []}
                  rowCount={conductJhaListData?.data?.result?.itemsCount ?? 0}
                  columns={credcloumns}
                  loading={isLoading}
                  checkboxSelection={false}
                  page={page}
                  pagination
                  pageSize={pageSize}
                  onClick={(rows) => onRowClick(rows)}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeChange}
                  onPageChange={handlePagignation}
                  backIconButtonProps={{ disabled: false }}
                  disableSelectionOnClick
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
